import * as React from 'react';
import { useSelector } from 'react-redux';

import { VideoFromDeveloperBlock } from '../../components/VideoFromDeveloperBlock/VideoFromDeveloperBlock';
import { getTemplateSpecialPromoVideo } from '../../selectors/developerV2/templateSpecialPromo/getTemplateSpecialPromoVideo';

export const VideoFromDeveloperBlockShSPContainer: React.FC = () => {
  const video = useSelector(getTemplateSpecialPromoVideo);

  if (!video) {
    return null;
  }

  return <VideoFromDeveloperBlock src={video.link} poster={video.preview?.url} disclaimer={video.disclaimer} />;
};
